/**
 * The panel's motion vocabulary — one source so the rules stay enforceable
 * instead of copy-pasted:
 *  - every entrance/exit rides the signature ease-out curve (matches the
 *    sidebar's CSS `cubic-bezier(0.23,1,0.32,1)`);
 *  - exits are always FASTER than the entrance they mirror (enter/panel pair
 *    with exit/exitFast).
 * CSS-side twins (sidebar width tween, donut arc, scroller pill) live in
 * their stylesheets and must match by hand.
 */

// Mutable tuple type — framer's Easing typing rejects readonly arrays.
export const EASE_OUT: [number, number, number, number] = [0.23, 1, 0.32, 1]

/**
 * Pause between picking a question option and auto-advancing to the next
 * question, so the selection visibly registers before the view moves.
 */
export const SELECTION_HOLD_MS = 180

export const DURATION = {
  /** Row/item exits (queue rows). */
  exitFast: 0.12,
  /** Panel/strip exits and confirmation pops. */
  exit: 0.15,
  /** Row/item entrances (transcript, queue rows). */
  enter: 0.18,
  /** Minor state flips (chevron rotate, phrase crossfade). */
  minor: 0.2,
  /** Panel/strip entrances (queue card, Generating strip). */
  panel: 0.25,
  /** Widget mount reveals (tracker, eval card, approval group). */
  mount: 0.3,
} as const

/**
 * First-open welcome entrance (empty state + suggestion chips) — the panel's
 * one first-run delight beat. The two blocks live in different subtrees, so
 * each hoists its own container; the chips take a small delay so the welcome
 * text settles first.
 */
export const welcomeContainer = (delayChildren = 0) => ({
  hidden: {},
  visible: { transition: { staggerChildren: 0.05, delayChildren } },
})

export const welcomeItem = {
  hidden: { opacity: 0, transform: 'translateY(8px)' },
  visible: {
    opacity: 1,
    transform: 'translateY(0px)',
    transition: { duration: DURATION.enter, ease: EASE_OUT },
  },
}
